import styled from '@emotion/styled'
import { Tabs } from '@mui/material';


export const TabsStyled = styled(Tabs)`
    background-color: transparent;
    min-height: auto;
    border-bottom: 2px solid #d1d5db;

    .MuiTabs-flexContainer {
        gap: 3px;
    }

    .MuiTabs-indicator {
        display: none;
    }
`;
